import OriginalNotification from './Notification.svelte';
import OriginalContent from './Content.svelte';
import OriginalLeading from './Leading.svelte';
import Avatar from './Avatar.svelte';
import Description from './Description.svelte';
import Extra from './Extra.svelte';
import Title from './Title.svelte';
import Icon from '../icon/Icon.svelte';
const Notification = OriginalNotification;
Notification.Leading = OriginalLeading;
Notification.Leading.Avatar = Avatar;
Notification.Leading.Icon = Icon;
Notification.Content = OriginalContent;
Notification.Content.Title = Title;
Notification.Content.Description = Description;
Notification.Extra = Extra;
export default Notification;
